import { createAction } from '@reduxjs/toolkit';

import { studentReducerTypes, studentSingleReducerTypes } from 'types';

export const STUDENT_DATA_SAGA = 'STUDENT_DATA_SAGA';
export const studentDataSaga = createAction<studentReducerTypes.IStudentDataForm>(STUDENT_DATA_SAGA);

export const STUDENT_DATA_SINGLE_SAGA = 'STUDENT_DATA_SINGLE_SAGA';
export const studentDataSingleSaga =
    createAction<studentSingleReducerTypes.IStudentDataSingleForm>(STUDENT_DATA_SINGLE_SAGA);

export const STUDENT_DATA_UPDATE_SAGA = 'STUDENT_DATA_UPDATE_SAGA';
export const studentDataUpdateSaga = createAction<studentReducerTypes.IStudentDataUpdateForm>(STUDENT_DATA_UPDATE_SAGA);
